import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import CandidateDetailLeft from "@/Components/common/client/candidatedetail/CandidateDetailLeft";
import CandidateDetailRight from "@/Components/common/client/candidatedetail/CandidateDetailRight";
import {
  deSelectAllListings,
  setCandidateDetails,
  setLoading,
  handleFetchCandidateDetails,
} from "@/reducers/clientcandidatedetail";
import { updateactivePages } from "@/reducers/clientcommon";
import { fetchFiltersData } from "@/reducers/clientscandidates";

import EditBankCandidateComplianceModal from "../../Components/modals/client/EditBankCandidateComplianceModal";
import useTitle from "../../utilities/hooks/useTitle";
import { apiDecrypt } from "../../utilities/keyEncryption";

/**
 * Renders the CandidateDetail component.
 *
 * @param {Object} data - the candidate data
 * @param {Object} calData - the candidate calendar data
 * @return {JSX.Element} the rendered CandidateDetail component
 */
const CandidateDetail = ({ calData, candidateAvailabilitiesData }) => {
  useTitle("Candidate Details");

  const [data, setData] = useState({});
  const dispatch = useDispatch();
  const [candidateId, setCandidateId] = useState(null);
  const { showProfile } = useSelector((state) => state.clientCandidateDetail);
  const { id } = useParams();

  // const handleFetchCandidateCalendarShifts = async (candidate_id) => {
  //   const response = _fetchCandidateCalendarShifts({ candidate_id });
  //   response
  //     .then((res) => {
  //       const {
  //         data: { job_list = "", CandidateAvailabilitiesData = [] },
  //       } = res;
  //       // console.log(res);
  //       let calData = formatCandidateCalendarShifts(job_list);
  //       dispatch(setCandidateCalData(calData));
  //       dispatch(setCandidateAvailabilityData(CandidateAvailabilitiesData));
  //     })
  //     .catch((error) => {
  //       handleAPICatch(error);
  //     });
  // };
  // _fetchCandidateCalendarShifts

  // Listen for route changes and reset candidate details
  useEffect(() => {
    return () => {
      // Clear data when navigating away from this page
      dispatch(setCandidateDetails({}));
    };
  }, [location]);
  useEffect(() => {
    // if (candidateId === null && _.isEmpty(data)) {
    //   return;
    // }
    dispatch(deSelectAllListings());
    dispatch(fetchFiltersData());
    dispatch(setLoading(true));
  }, []);

  useEffect(() => {
    dispatch(
      updateactivePages({
        activePage: null,
        activeSubPage: null,
      }),
    );
    dispatch(handleFetchCandidateDetails(apiDecrypt(id)));
    // handleFetchCandidateCalendarShifts(apiDecrypt(id));
  }, []);

  return (
    <div className="CandidateDetail_Wrapper h-full">
      {/* <Head title={data?.candidate_name} /> */}
      <div
        className={`mb-6 flex h-full flex-col lg:flex-row ${showProfile ? "gap-4" : "gap-0"}`}
      >
        <CandidateDetailLeft />
        <CandidateDetailRight />
        <EditBankCandidateComplianceModal />
      </div>
    </div>
  );
};

export default CandidateDetail;
